import React from 'react';
import Spinner from './Spinner';

function LoadingSpinner() {
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-[var(--primary)] z-50">
            <Spinner></Spinner>
        </div>
    );
}

export default LoadingSpinner;
